import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css'; // <--- AKTIVERER TAILWIND OG DEN MAGISKE CURSOR

const rootElement = document.getElementById('root');

if (rootElement) {
  // Vi benytter React 19 metoden som set på søstersiden
  const root = ReactDOM.createRoot(rootElement);
  root.render(
         <App />
  );
} else {
  console.error("Kunne ikke finde root-elementet. Akademiet kan ikke manifesteres.");
}